// Preselects the inquiry form's "Worum geht es?" select from ?topic=<value>,
// so a call to action like /kontakt?topic=upgrade-check lands on the
// matching topic. Client-side on purpose: the EXT:form plugin renders
// cached and "topic" is excluded from the cHash, so the server-side
// markup is the same for every topic. Unknown values are ignored, and a
// value the visitor already picked (e.g. after a validation round trip)
// is never overwritten.
function initFormTopic(): void {
  const topic = new URLSearchParams(window.location.search).get('topic');
  if (!topic) {
    return;
  }
  document.querySelectorAll<HTMLSelectElement>('form[id^="inquiry"] select[id$="-topic"]').forEach((select) => {
    if (select.value !== '') {
      return;
    }
    if ([...select.options].some((option) => option.value === topic)) {
      select.value = topic;
    }
  });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initFormTopic) : initFormTopic();
